import React from "react";
import { IdcardOutlined } from "@ant-design/icons";
import { Tag } from "antd";
export default function TWICTag({ bold }) {
    return (React.createElement(Tag, { color: "purple", icon: React.createElement(IdcardOutlined, null), style: { fontWeight: bold ? "bold" : "normal" } }, "TWIC"));
}
TWICTag.defaultProps = {
    bold: false,
};
